import { ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/toaster";
import { queryClient } from "@/shared/queryClient";
import { NotificationProvider } from "./NotificationProvider";
import { NotificationAlertProvider } from "@/shared/components";
import { AuthContextProvider } from "@/lib/authContext";
import { OfflineOutboxSync } from "@/features/offline/OfflineOutboxSync";

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <AuthContextProvider>
          <OfflineOutboxSync />
          <NotificationProvider>
            <NotificationAlertProvider>
              {children}
              <Toaster />
            </NotificationAlertProvider>
          </NotificationProvider>
        </AuthContextProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
}
